import React, { useRef, useState } from 'react';
import ReactPlayer from 'react-player';
import './StepHeader.css';

/** Portal V2 only — short guided copy from classic step title (V1 unchanged). */
function getPortalV2VideoCopy(title) {
    const t = String(title || '').toUpperCase();
    if (t.includes('TOP 7')) {
        return {
            lead: 'Watch the Top 7 intro',
            sublead:
                'This short video prepares you for the next part of Step 2.',
        };
    }
    if (t.includes('OOLA ONE')) {
        return {
            lead: 'Watch the Oola One intro',
            sublead: 'A quick guide before you choose your priority goal.',
        };
    }
    if (t.includes('STEP 3') || t.includes('ACTION')) {
        return {
            lead: 'Watch this short video to continue.',
            sublead: 'See how daily actions connect to your Top 7.',
        };
    }
    if (t.includes('STEP 2')) {
        return {
            lead: 'Watch this short video to continue.',
            sublead: 'This prepares you for setting your goals.',
        };
    }
    return {
        lead: 'Watch this short video to continue.',
        sublead: null,
    };
}

const StepHeaders = ({ title, url, mobile, changePage, portalV2 }) => {
    const [activeButton, ChangeActiveButton] = useState(false);
    const [show, Changeshow] = useState(true);
    const [started, setStarted] = useState(false);
    const [playing, setPlaying] = useState(false);
    const didAdvance = useRef(false);
    const startedRef = useRef(false);

    const premium = Boolean(portalV2);

    const goNext = () => {
        if (didAdvance.current) return;
        didAdvance.current = true;
        ChangeActiveButton(true);
        changePage();
        setTimeout(function () {
            Changeshow(false);
        }, 1000);
    };

    function changePlay() {
        if (premium) {
            goNext();
            return;
        }
        changePage();
        setTimeout(function () {
            Changeshow(false);
        }, 1000);
    }

    if (premium) {
        const { lead, sublead } = getPortalV2VideoCopy(title);

        return (
            <div className="header__container pv2-video-step">
                <div className="video__container">
                    <h1 className="header__title">{title}</h1>
                    <div className="pv2-video-step__shell">
                        <p className="pv2-video-step__lead">{lead}</p>
                        {sublead ? (
                            <p className="pv2-video-step__sublead">{sublead}</p>
                        ) : null}
                        {show === true && (
                            <div
                                className={`pv2-video-step__card${
                                    started ? ' is-playing' : ' is-idle'
                                }`}
                            >
                                <ReactPlayer
                                    url={url}
                                    className="video__player"
                                    width="100%"
                                    height="100%"
                                    controls={started}
                                    playing={playing}
                                    light={!started}
                                    playIcon={
                                        <span
                                            className="pv2-video-step__play"
                                            aria-hidden="true"
                                        >
                                            <span className="pv2-video-step__play-icon" />
                                        </span>
                                    }
                                    onClickPreview={() => {
                                        startedRef.current = true;
                                        setStarted(true);
                                        setPlaying(true);
                                    }}
                                    onPlay={() => {
                                        startedRef.current = true;
                                        setStarted(true);
                                        setPlaying(true);
                                    }}
                                    onPause={() => setPlaying(false)}
                                    onEnded={goNext}
                                    progressInterval={800}
                                    onProgress={({ played }) => {
                                        if (
                                            startedRef.current &&
                                            played >= 0.995
                                        ) {
                                            goNext();
                                        }
                                    }}
                                />
                            </div>
                        )}
                    </div>
                    <div className="button__container">
                        <p className="pv2-video-step__unlock is-ready">
                            Or tap Next to continue.
                        </p>
                        <button
                            className="button__next buttonVideoNext"
                            onClick={() => changePlay()}
                            type="button"
                        >
                            Next
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    const VideoComp = (
        <div className="header__container">
            <div className="video__container">
                <h1 className="header__title">{title}</h1>
                {show === true && (
                    <ReactPlayer
                        url={url}
                        className="video__player"
                        width="100%"
                        height="50vh"
                        controls
                        onPlay={() => ChangeActiveButton(true)}
                    />
                )}
                <div className="button__container">
                    <button
                        className={` ${
                            activeButton
                                ? ' button__next buttonVideoNext'
                                : 'btnDisableStep1'
                        }`}
                        onClick={() => changePlay()}
                        type="button"
                    >
                        NEXT
                    </button>
                </div>
            </div>
        </div>
    );
    return VideoComp;
};

export default StepHeaders;
